export const state = {
	subscriptions: [],
	lastPaymentFailInfo: null
}



// WEBPACK FOOTER //
// ./src/common/store/Subscriptions/state.js